
















































































import { Component, Vue, Prop } from 'vue-property-decorator';

import InputComponent from '@/components/FormElements/InputComponent.vue';
import LabelComponent from '@/components/FormElements/LabelComponent.vue';
import BaseVue from '@/api/core/BaseVue';

@Component({
  components: {
    InputComponent,
    LabelComponent,
  },
})
export default class EventContactPromotorModalComponent extends BaseVue {
  public $refs!: {
    modal: any;
  };

  @Prop(String) public readonly eventId!: string;
  @Prop(String) public readonly id!: string;

  private emailAddress: string = '';
  private message: string = '';

  private reset() {
    this.busy = false;
    this.emailAddress = '';
    this.message = '';
  }

  private submitForm() {
    const promises: any = [];
    promises.push(this.$validator.validateAll());

    Promise.all(promises).then((validations) => {
      // If one validation has failed, we stop here
      if (validations.some((validation) => validation === false)) {
        return;
      }

      if (this.api === null) {
        return;
      }
      this.busy = true;
      // Do some processing ...
      const mutation = {
        userEmail: this.emailAddress,
        content: this.message,
      };

      this.api
        .contactPromoter(this.eventId, mutation)
        .then((res) => {
          this.handleMessage(res);
          this.busy = false;
          this.$refs.modal.hide();
        })
        .catch(this.handleFailure);
    });
  }

  private cancelModal() {
    this.emailAddress = '';
    this.message = '';

    this.$refs.modal.hide();
  }
}
